import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { TubbzProvider } from './context/TubbzContext';
import ProtectedRoute  from './components/ProtectedRoute';
import './styles/globals.css';

const AttractPage    = lazy(() => import('./pages/AttractPage'));
const EmailPage      = lazy(() => import('./pages/EmailPage'));
const CameraPage     = lazy(() => import('./pages/CameraPage'));
const ProcessingPage = lazy(() => import('./pages/ProcessingPage'));
const CustomisePage  = lazy(() => import('./pages/CustomisePage'));
const FinalPage      = lazy(() => import('./pages/FinalPage'));
const ResultPage     = lazy(() => import('./pages/ResultPage'));
const EventPage      = lazy(() => import('./pages/EventPage'));
const AuthPage       = lazy(() => import('./pages/AuthPage'));
const Dashboard      = lazy(() => import('./pages/Dashboard'));
const Profile        = lazy(() => import('./pages/Profile'));
const ComingSoon     = lazy(() => import('./pages/ComingSoon'));

/* Page loading fallback component */
function PageFallback() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#0d1117',
      color: '#00afee',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 48,
          height: 48,
          border: '4px solid rgba(0, 175, 238, 0.2)',
          borderTopColor: '#00afee',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 16px'
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <span style={{ fontSize: '14px', letterSpacing: '1px', opacity: 0.8 }}>LOADING...</span>
      </div>
    </div>
  );
}

/* Thin top-of-page progress bar on navigation */
function NavProgress() {
  const location = useLocation();
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 700);
    return () => clearTimeout(t);
  }, [location]);
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, height: 3, zIndex: 9999,
      background: visible ? 'linear-gradient(90deg,#f3c318,#00afee)' : 'transparent',
      transform: visible ? 'scaleX(1)' : 'scaleX(0)',
      transformOrigin: 'left',
      transition: visible ? 'transform .7s ease' : 'background .3s ease',
    }}/>
  );
}

export default function App() {
  return (
    <TubbzProvider>
      <BrowserRouter>
        <NavProgress/>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<ComingSoon/>}/>
            <Route path="/attract"  element={<AttractPage/>}/>
            <Route path="/event"    element={<EventPage/>}/>
            <Route path="/email"    element={<EmailPage/>}/>
            <Route path="/auth/" element={<AuthPage/>}/>
            {/* <Route element={<ProtectedRoute/>}> */}
              <Route path="/camera"     element={<CameraPage/>}/>
              <Route path="/processing" element={<ProcessingPage/>}/>
              <Route path="/customise"  element={<CustomisePage/>}/>
              <Route path="/final"      element={<FinalPage/>}/>
              <Route path="/result/:uniqueId" element={<ResultPage/>}/>
            {/* </Route> */}
            <Route path="/profile" element={<Profile/>}/>
            <Route path="/dashboard" element={<Dashboard/>}/>
            <Route path="*" element={<Navigate to="/" replace/>}/>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TubbzProvider>
  );
}
